import React from 'react';
import './PWALayout.css';

/**
 * PWA Layout Component
 * Provides a consistent layout structure for PWA mode with proper viewport handling
 * and safe area support for mobile/tablet devices
 */
const PWALayout = ({ header, children, footer, className = '' }) => {
  return (
    <div className={`pwa-layout ${className}`}>
      {header && (
        <header className="pwa-layout-header">
          {header}
        </header>
      )}
      <main className="pwa-layout-content">
        {children}
      </main>
      {footer && (
        <footer className="pwa-layout-footer">
          {footer}
        </footer>
      )}
    </div>
  );
};

export default PWALayout;


